import React from 'react';
import { AppIconListItem } from '../../../_lib/components/AppIconList';
import {
  ContainerWithCommonContextMenu,
} from '../../../_lib/components/ContextMenu';
import { AppLibraryEditableElement } from '../AppLibraryTypes';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';
import IForm from '../../../types/IForm';
import { asDraggableContentListItem, useSortableListItem } from '../../../_lib/components/SortableContentList';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { StatusInfoError } from '../../../_lib/components/StatusInfo';
import { ContextMenuButtonProps } from '../../../_lib/components/ContextMenu/partials/ContextMenuButton';

type AppLibraryListItemProps = AppLibraryEditableElement & {
  openEditForm?: (form: IForm) => void;
  openDeleteForm?: (form: IForm) => void;
};

function AppLibraryListItem(props: AppLibraryListItemProps) {
  const { delete: deleteForm, edit, id, image, link, optional, openDeleteForm, openEditForm } = props;

  const { move, nextItemId, prevItemId, error } = useSortableListItem(id);

  const { t } = useSonTranslation('AppLibrary');

  const contextMenuActions: ContextMenuButtonProps[] = [
    ...openEditForm
      ? [{
          children: t('editLink'),
          key: 'edit',
          onClick: (event) => {
            event.preventDefault();
            event.stopPropagation();

            openEditForm(edit);
          },
        }] as ContextMenuButtonProps[]
      : [],
    ...openDeleteForm
      ? [{
          children: t('removeLink'),
          key: 'remove',
          onClick: (event) => {
            event.preventDefault();
            event.stopPropagation();

            openDeleteForm(deleteForm);
          },
        }] as ContextMenuButtonProps[]
      : [],
    {
      children: t('moveUp'),
      key: 'moveElementUp',
      disabled: !prevItemId,
      onClick: (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (prevItemId) {
          move(prevItemId);
        }
      },
    },
    {
      children: t('moveDown'),
      key: 'moveElementDown',
      disabled: !nextItemId,
      onClick: (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (nextItemId) {
          move(nextItemId);
        }
      },
    },
  ];

  return (
    <div className="app-library__container">
      <ContainerWithCommonContextMenu
        toolTip={t('manageLink', { name: link.name })}
        toolTipPlacement={TooltipPlacement.TOP}
        actions={contextMenuActions}
      >
        <div className="app-library__element">
          {image?.src && (
            <div className="app-library__icon">
              <AppIconListItem modifier="small" src={image.src} />
            </div>
          )}
          <div className="app-library__content">{link.name + (optional ? ` (${t('optional')})` : '')}</div>
        </div>
      </ContainerWithCommonContextMenu>
      {error && <StatusInfoError message={t('errorResponse')} modifier="padding-top" />}
    </div>
  );
}
export const DraggableAppLibraryListItem = asDraggableContentListItem(AppLibraryListItem);
